import React from 'react';
import Localize from 'react-intl-universal';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import ListCard from '@components/ListCard/ListCard';

const StyledBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    height: 'max-content'
  },
  height: 'fit-content',
  [theme.breakpoints.up('md')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('lg')]: {
    height: '67.3vh'
  },
  width: '100%',
  padding: '2rem 1rem 1rem 1rem',
  overflow: 'auto',
  backgroundColor: theme.palette.booking.list
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginTop: '2.25rem',
  marginBottom: '0.5rem',
  fontSize: '20px',
  color: theme.palette.booking.header
}));

const SessionsList = ({ sessions, handleSession, checkValue }) => {
  return (
    <StyledBox data-testid={'SessionList'}>
      <StyledTypography>{Localize.get('Booking.availableSessions')}</StyledTypography>
      {sessions.map((session) => (
        <ListCard
          key={session?.id}
          session={session}
          handleSession={handleSession}
          checkValue={checkValue}
        />
      ))}
    </StyledBox>
  );
};

export default SessionsList;
